// import {
//   countries as countriesData,
//   timeZone,
// } from "../../../resources/LocationData";
import { useEffect, useState } from "react";
import Styles from "./locationStyle.module.css";
import { toast, ToastContainer } from "react-toastify";
import { MdEditDocument } from "react-icons/md";
import {
  DatePicker,
  Collapse,
  Select,
  Button,
  Radio,
  Table,
  Modal,
  Form,
  Input,
  InputNumber,
  Switch,
  Space,
  Typography,
  Flex,
  Checkbox,
} from "antd";
import { FaDownload } from "react-icons/fa6";

const ContractDetailsComponent = ({ contractDetails, setContractDetails, isApprover, approvalStage, siteStatus, setSiteStatus, isApproverView }) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [countryOPtions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [timeZoneOptions, setTimeZoneOptions] = useState([]);
  //   console.log("contractDetails details: ", contractDetails);


  const submitForm = (isCompleted) => {
    if (isCompleted) {
      if (
        Object.values(contractDetails).filter((value) => value !== null)
          .length === Object.values(contractDetails).length
      ) {
        form.submit();
        setContractDetails((prev) => ({
          ...prev,
          isSectionCompleted: true,
        }));
        // Submit the form
      } else {
        setContractDetails((prev) => ({
          ...prev,
          isSectionCompleted: false,
        }));
        // Reset the checkbox in the form
        form.setFieldsValue({
          isSectionCompleted: false,
        });

        toast.error(
          "Please fill all the details before marking the section as completed."
        );
      }
    }
  };

  //   const handleCountryChange = (selectedCountry) => {
  //     setlocationDetails((prev) => ({
  //       ...prev,
  //       country: selectedCountry,
  //       state: null,
  //       city: null,
  //     }));
  //     setStateOptions(Object.keys(countriesData[selectedCountry] || {}));
  //     setCityOptions([]);
  //     // form.resetFields(['city']);
  //     // form.resetFields(['state']);
  //     form.setFieldsValue({
  //       state: null,
  //       city: null, // Explicitly set the city value to null/undefined/'' in the Form
  //     });
  //   };

  //   const handleStateChange = (selectedState) => {
  //     setlocationDetails((prev) => ({
  //       ...prev,
  //       state: selectedState,
  //       city: null,
  //     }));
  //     setCityOptions(
  //       countriesData[locationDetails.country]?.[selectedState] || []
  //     );
  //     form.setFieldsValue({
  //       state: selectedState,
  //       city: null, // Explicitly set the city value to null/undefined/'' in the Form
  //     });
  //   };

  //   const handleCityChange = (selectedCity) => {
  //     setlocationDetails((prev) => ({
  //       ...prev,
  //       city: selectedCity,
  //     }));
  //   };

  return (
    <div className={Styles[`main-div`]}>
      <div className={Styles["location-head-div"]}>
        <div>
          <span>
            {" "}
            {contractDetails?.isSectionCompleted && isApprover && isApproverView && (
              <Button
                className={Styles["edit-btn"]}
                disabled={!contractDetails?.isSectionCompleted || siteStatus === "Live" || siteStatus === "Pre Live" || approvalStage !== 'PendingApproval'}
                onClick={() => {
                  setContractDetails((prev) => ({
                    ...prev,
                    isSectionCompleted: false,
                  }));
                  form.setFieldsValue({
                    isSectionCompleted: false,
                  });
                }}
              >
                {" "}
                <MdEditDocument
                  className={Styles["location-edit-icon"]}
                />{" "}
                Edit
              </Button>
            )}
          </span>
        </div>
      </div>

      <Form
        className={Styles["form-grid"]}
        form={form}
        initialValues={contractDetails}
        disabled={contractDetails?.isSectionCompleted || (approvalStage === "Approved") || (approvalStage === "PendingApproval" && isApprover === false)}
      >
        <Form.Item
          name="contractSentDate"
          label="Contract Sent Date"
          rules={[{ required: true, message: "Please input contract sent date!" }]}
        >
          <DatePicker onChange={(date) => {
            setContractDetails(prev => ({
              ...prev,
              contractSentDate: date ? new Date(date) : null
            }))
          }} />
        </Form.Item>
        <Form.Item
          name="contractSignedDate"
          label="Contract Signed Date"
          rules={[{ required: true, message: "Please input contract signed date!" }]}
        >
          <DatePicker onChange={(date) => {
            setContractDetails(prev => ({
              ...prev,
              contractSignedDate: date ? new Date(date) : null
            }))
          }} />
        </Form.Item>

        <Form.Item
          name="contractStartDate"
          label="Contract Start Date"
          rules={[{ required: true, message: "Please input contract start date!" }]}
        >
          <DatePicker onChange={(date) => {
            setContractDetails(prev => ({
              ...prev,
              contractStartDate: date ? new Date(date) : null
            }))
          }} />
        </Form.Item>

        <Form.Item
          name="contractEndDate"
          label="Contract End Date"
          rules={[{ required: true, message: "Please input contract end date!" }]}
        >
          <DatePicker onChange={(date) => {
            setContractDetails(prev => ({
              ...prev,
              contractEndDate: date ? new Date(date) : null
            }))
          }} />
        </Form.Item>
          {/* valuePropName="checked" */}
        <Form.Item name="paid"  label="Payment Received"> 

          <Select value={contractDetails.paid} onChange={value => setContractDetails(prev => ({
            ...prev,
            paid: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>

          {/* <Checkbox
            onChange={(e) => {
                setContractDetails(prev => ({
                  ...prev,
                  paid: e.target.checked
              }));
              
            }}
          >
            {" "}
            Payment Received
          </Checkbox> */}
        </Form.Item>

        <Form.Item
          name="paymentDate"
          label="Payment Date"
          rules={[{ required: true, message: "Please input payment date!" }]}
        >
          <DatePicker onChange={(date) => {
            setContractDetails(prev => ({
              ...prev,
              paymentDate: date ? new Date(date) : null
            }))
          }} />
        </Form.Item>



        {isApprover && isApproverView && <Form.Item className={Styles["full-width"]} name="isSectionCompleted" valuePropName="checked">
          <Checkbox
            disabled={
              Object.values(contractDetails).filter((value) => value !== null)
                .length /
              Object.values(contractDetails).length <
              1 || contractDetails?.isSectionCompleted
            }
            onChange={(e) => {
              //   setlocationDetails(prev => ({
              //     ...prev,
              //     isLocationSectionCompleted: e.target.checked
              // }));
              submitForm(e.target.checked);
            }}
          >
            {" "}
            Verified and Completed.
          </Checkbox>
        </Form.Item>}
      </Form>
    </div>
  );
};
export default ContractDetailsComponent;
